<ng-container *transloco="let t">
  <app-lex-xi-side-panel
    [isLoading]="isLoading"
    [selectedItem]="selectedGroup"
    [verticalTabBarData]="[
      {
        id: 'users',
        icon: 'users',
        hasSeparator: true,
        leftSideTemplate: leftSide,
        rightSideTemplate: rightSide,
      },
    ]"
  ></app-lex-xi-side-panel>

  <ng-template #leftSide>
    <div side="left" class="group-list__list-wrapper">
      <div class="group-list__group-list-header">
        <h3 class="group-list__group-list-label">{{ t('group-list.user-groups') }}</h3>

        @if (groups?.length) {
          <xi-fab
            icon="fab_plus"
            color="orca"
            buttonSize="normal"
            (onClick)="onCreateGroup()"
            [disabled]="!canCreateGroup()"
            [tooltip]="{ text: t('group-list.create-group-tooltip'), direction: 12 }"
          >
          </xi-fab>
        }
      </div>

      <div class="group-list__scroll">
        @if (groups.length && !isLoading) {
          <xi-list
            select="single"
            size="large"
            [hasSearch]="!!groups?.length"
            [hasDragging]="false"
            [hasBorder]="false"
            [internalProps]="internalProps"
            [value]="selectedGroup"
            [localization]="{
              noResultsFound: t('group-list.no-results-found'),
              clearSearch: t('group-list.clear-search-button'),
            }"
          >
            <div slot="children">
              @for (group of filteredGroups; track group) {
                <div>
                  <xi-list-item
                    [value]="group.group_name"
                    (onItemClick)="onGroupSelected(group)"
                    [checked]="selectedGroup === group"
                    [ngClass]="selectedGroup === group ? 'kxi-text-600' : ''"
                  >
                    <div slot="children" class="group-list__group-list-item-text">
                      <div *appMiddleEllipsize="group.group_name"></div>
                    </div>
                  </xi-list-item>
                </div>
              }
            </div>
          </xi-list>
        } @else {
          <ng-template [ngTemplateOutlet]="noGroups"></ng-template>
        }
        @if (!groups?.length && !isLoading) {
          <app-empty-side-panel
            emptyViewText="{{ t('group-list.empty-text') }}"
            emptyViewTitle="{{ t('group-list.empty-title') }}"
            ctaButtonText="{{ t('group-list.empty-cta-btn-text') }}"
            (ctaButtonClick)="onCreateGroup()"
          ></app-empty-side-panel>
        }
      </div>
    </div>
  </ng-template>

  <ng-template #rightSide>
    <div side="right">
      <app-group-users
        [group]="selectedGroup"
        [groupList]="filteredGroups"
        (groupDelete)="onGroupDeleted($event)"
        (groupChange)="onGroupChanged()"
      >
      </app-group-users>
    </div>
  </ng-template>

  <!-- Group Create Modal -->
  @if (showGroupCreateModal) {
    <app-lex-xi-modal
      [isVisible]="showGroupCreateModal"
      maxWidth="512px"
      (close)="onGroupCreateModalClosed(null)"
    >
      <ng-template appXIModalContent>
        @if (showGroupCreateModal) {
          <app-group-create-dialog
            [data]="groupCreateData"
            (modalClosed)="onGroupCreateModalClosed($event)"
          ></app-group-create-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
</ng-container>
